import React from 'react';
import { Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { IControlProps } from '../types/IFormSettings';
import { updateFormControlValueAction } from '../actions/formActions';
import { controlSelector } from '../selectors/formBuilder.selector';
import FormTooltip from './FormTooltip';

function Checkbox({ controlName, formName }: IControlProps) {
    const dispatch = useDispatch();
    const { readonly, label, value, required, tooltip } = useSelector(
        controlSelector(formName, controlName),
    );

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.currentTarget;
        dispatch(
            updateFormControlValueAction({
                formName,
                value: checked,
                controlName,
            }),
        );
    };

    return (
        <>
            <Row>
                <div className="col-12">
                    <input
                        id={controlName}
                        className="form-control d-none"
                        type="checkbox"
                        checked={Boolean(value)}
                        name={controlName}
                        onChange={onChangeHandler}
                        readOnly={readonly}
                    />
                    <label id={`anc_${controlName}`} htmlFor={controlName}>
                        <span />
                        <div dangerouslySetInnerHTML={{ __html: label }} />
                        {required && <span className="required">*</span>}
                        {tooltip && <FormTooltip tooltip={tooltip} />}
                    </label>
                </div>
            </Row>
        </>
    );
}

export default Checkbox;
